module.exports = __webpack_public_path__ + "static/img/pinpai-29.a9019193.png";